import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';

import { Icon } from '../../../icon/enums/icon';
import { IconComponent } from '../../../icon/components/icon/icon.component';

@Component({
  selector: 'app-rate',
  imports: [IconComponent],
  templateUrl: './rating.component.html',
  styleUrl: './rating.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingComponent {
  public readonly maxRating = input<number>(5);
  public readonly rating = input.required<number>();

  protected readonly stars = this.starsSignal();

  protected icon(star: 'full' | 'half' | 'empty'): Icon {
    switch (star) {
      case 'full':
        return Icon.StarFill;

      case 'half':
        return Icon.StarHalf;

      default:
        return Icon.Star;
    }
  }

  private starsSignal(): Signal<Array<'full' | 'half' | 'empty'>> {
    return computed(() => {
      const rating = this.rating();
      const maxRating = this.maxRating();
      const fullStarCount = Math.floor(rating);
      const halfStarCount = rating % 1 >= 0.5;
      const emptyStarCount =
        maxRating - fullStarCount - (halfStarCount ? 1 : 0);

      return [
        ...Array(fullStarCount).fill('full'),
        ...(halfStarCount ? ['half'] : []),
        ...Array(emptyStarCount).fill('empty'),
      ];
    });
  }
}
